<template>
  <lb-dialog
    :value="value"
    @input="$emit('input', $event)"
    :heading="isEditing ? 'Edit Filter' : 'Add Filter'"
    width="560"
    :loading="loading"
    data-testid="step-filter-config__dialog"
  >
    <template v-slot:body>
      <v-row class="mt-0">

        <!-- File Type Comparison -->
        <v-col cols="12" class="py-2">
          <lb-dropdown
            label="Dataset combination *"
            placeholder="Select dataset combination"
            :items="fileTypeOptions"
            itemtext="name"
            itemvalue="value"
            v-model="localForm.filetype"
            :error="formErrors.filetype"
            data-testid="step-filter-config__filetype-dropdown"
          />
        </v-col>

        <!-- Tag -->
        <v-col cols="12" class="py-2">
          <lb-string
            label="Tag *"
            placeholder="Enter tag"
            v-model.trim="localForm.tag"
            :error="formErrors.tag"
            data-testid="step-filter-config__tag-input"
          />
        </v-col>

        <!-- Description -->
        <v-col cols="12" class="py-2">
          <lb-textBox
            label="Description *"
            placeholder="Enter description"
            requriedrows="3"
            v-model.trim="localForm.description"
            :error="formErrors.description"
            data-testid="step-filter-config__desc-input"
          />
        </v-col>

        <!-- Exclude / Delete type -->
        <v-col cols="12" class="py-2 d-flex">
          <p class="caption d-flex align-center">Filter Action*</p>
          <v-radio-group
            v-model="localForm.excludetype"
            row
            dense
            hide-details
            class="pt-0 mt-0"
            :error-messages="formErrors.excludetype ? [formErrors.excludetype] : []"
            data-testid="step-filter-config__excludetype-radio"
          >
            <v-radio
              v-for="(t, idx) in excludeTypes"
              :key="idx"
              :label="t"
              :value="t"
            />
          </v-radio-group>
        </v-col>

        <!-- Table -->
        <v-col cols="6" class="py-2">
          <lb-dropdown
            label="Table *"
            placeholder="Select table"
            :items="tables"
            itemtext="name"
            itemvalue="_id"
            v-model="localForm.tableid"
            :error="formErrors.tableid"
            data-testid="step-filter-config__table-dropdown"
            @input="onTableChange"
          />
        </v-col>

        <!-- Column -->
        <v-col cols="6" class="py-2">
          <lb-dropdown
            label="Column *"
            placeholder="Select column"
            :items="columnOptions"
            v-model="localForm.column"
            :error="formErrors.column"
            data-testid="step-filter-config__column-dropdown"
          />
        </v-col>

        <!-- Operator -->
        <v-col cols="12" class="py-2">
          <lb-dropdown
            label="Filter Criteria *"
            placeholder="Select operator"
            :items="operators"
            v-model="localForm.operator"
            :error="formErrors.operator"
            data-testid="step-filter-config__operator-dropdown"
          />
        </v-col>

        <!-- Filter word -->
        <v-col cols="12" class="py-2">
          <lb-string
            label="Filter Value *"
            placeholder="Enter filter value"
            v-model.trim="localForm.filterword"
            :error="formErrors.filterword"
            data-testid="step-filter-config__filterword-input"
          />
        </v-col>

        <!-- Knockoff matching -->
        <v-col cols="12" class="py-2">
          <v-checkbox
            v-model="localForm.isKnockOffFilter"
            label="Apply Knockoff matching?"
            dense
            hide-details
            class="mt-0 pt-0"
            data-testid="step-filter-config__knockoff-checkbox"
          />
        </v-col>

      </v-row>
    </template>

    <template v-slot:actions>
      <span class="caption text--secondary">* Required</span>
      <v-spacer />
      <base-button
        outlined
        label="Cancel"
        class="mr-2"
        data-testid="step-filter-config__dialog-cancel-btn"
        @click="$emit('cancel')"
      />
      <base-button
        primary
        :label="isEditing ? 'Update' : 'Add Filter'"
        :loading="loading"
        data-testid="step-filter-config__dialog-submit-btn"
        @click="$emit('submit', { ...localForm })"
      />
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'FilterFormDialog',

  props: {
    value:           { type: Boolean, default: false },
    isEditing:       { type: Boolean, default: false },
    loading:         { type: Boolean, default: false },
    initialForm:     { type: Object,  default: () => ({}) },
    formErrors:      { type: Object,  default: () => ({}) },
    fileTypeOptions: { type: Array,   default: () => [] },
    excludeTypes:    { type: Array,   default: () => [] },
    tables:          { type: Array,   default: () => [] },
    columnOptions:   { type: Array,   default: () => [] },
    operators:       { type: Array,   default: () => [] },
  },

  data() {
    return {
      localForm: { ...this.initialForm },
    };
  },

  watch: {
    value(newVal) {
      if (newVal) this.localForm = { ...this.initialForm };
    },
    initialForm: {
      deep: true,
      handler(newVal) {
        if (!this.value) {
          this.localForm = { ...newVal };
        }
      },
    },
  },

  methods: {
    onTableChange() {
      this.localForm.column = '';
      this.$emit('tableid-change', this.localForm.tableid);
    },
  },
};
</script>
